import * as uuid from 'uuid';

export function randomUUID(): string {
  return uuid.v4();
}


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/utils/uuid.ts